import React from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaClock, FaTag } from 'react-icons/fa';
import './Blog.css';

const Blog = () => {
    const posts = [
        {
            title: 'Getting Started with the MERN Stack',
            excerpt: 'A beginner-friendly walkthrough of setting up a full-stack project with MongoDB, Express, React, and Node.js from scratch.',
            tags: ['React', 'Node.js', 'MongoDB'],
            date: 'Feb 2025',
            readTime: '5 min read',
            url: 'https://dev.to/lakshmananr',
            color: '#667eea'
        },
        {
            title: 'My Journey into AI & Data Science',
            excerpt: 'How I started learning machine learning as a B.Tech student — resources, roadmaps, and the projects that got me excited.',
            tags: ['AI', 'Python', 'Learning'],
            date: 'Jan 2025',
            readTime: '4 min read',
            url: 'https://dev.to/lakshmananr',
            color: '#764ba2'
        },
        {
            title: 'Building AGR Creative Tech Studio',
            excerpt: 'The story of co-founding a tech studio while still in college — challenges, learnings, and what drives us forward.',
            tags: ['Startup', 'Entrepreneurship'],
            date: 'Dec 2024',
            readTime: '6 min read',
            url: 'https://dev.to/lakshmananr',
            color: '#f093fb'
        },
    ];

    return (
        <section className="blog section" id="blog">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="section-title">Blog / Articles</h2>
                    <p className="section-subtitle">Thoughts, learnings &amp; stories</p>
                </motion.div>

                <div className="blog-grid">
                    {posts.map((post, index) => (
                        <motion.a
                            key={index}
                            href={post.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="blog-card"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -6, transition: { duration: 0.2 } }}
                        >
                            {/* Accent bar */}
                            <div className="blog-accent" style={{ background: post.color }} />

                            <div className="blog-body">
                                <div className="blog-meta">
                                    <span className="blog-date"><FaClock /> {post.date}</span>
                                    <span className="blog-read">{post.readTime}</span>
                                </div>

                                <h3 className="blog-title">{post.title}</h3>
                                <p className="blog-excerpt">{post.excerpt}</p>

                                <div className="blog-tags">
                                    {post.tags.map((tag, ti) => (
                                        <span key={ti} className="blog-tag">
                                            <FaTag /> {tag}
                                        </span>
                                    ))}
                                </div>

                                <div className="blog-read-more">
                                    Read more <FaExternalLinkAlt />
                                </div>
                            </div>
                        </motion.a>
                    ))}
                </div>

                <motion.div
                    className="blog-cta"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    viewport={{ once: true }}
                >
                    <a
                        href="https://dev.to/lakshmananr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline"
                    >
                        View all articles
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default Blog;
